<div class="loading" [class.static]="static()"></div>
